import { render, staticRenderFns } from "./NewHeaderWeb.vue?vue&type=template&id=64d492d7&scoped=true"
import script from "./NewHeaderWeb.vue?vue&type=script&lang=ts"
export * from "./NewHeaderWeb.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64d492d7",
  null
  
)

export default component.exports